export default "__VITE_ASSET__da7fa83c__"